import type { Voucher } from '@src/domains/vouchers/types/voucher';

export function filterVouchersBySaleItem(vouchers: Voucher[], saleItemId: string): Voucher[] {
  return vouchers.filter((voucher) => voucher.saleItemId === saleItemId);
}
